<div class="main-content" [ngClass]="{'modelling': isModellingOnPage }">

    <div class="d-flex flex-row px-mb-20 chart-row">
        <div class="w-33">
            <div class="card">
                
                <div class="card-header d-flex flex-row justify-content-between">
                    <div class="me-auto px-ms-5">
                        AAMP
                    </div>
                    <span *ngIf="aampQuotas && user?.isAdmin" class="logo-btn-small setting"
                        (click)="openQuotaModal(false)">
                    </span>
                </div>


                <div class="px-p-10 custom-card-body" [class.scroll-y]="usedQuotaData?.length > 8">
                    <span class="title2" *ngIf="!usedQuotaData">Loading, Please wait...</span>
                    <div class="" *ngIf="usedQuotaData && usedQuotaData.length > 0" (mouseleave)="onAampTableBlur()">
                        <div id="aamp-tooltip" [class.show-tooltip]="showAampProductTooltip">
                            <p class="font-weight-bold">{{selectedTooltipProduct?.formattedUsedQuota}}</p>
                            <p>Av maturity: <br />
                                {{selectedTooltipProduct?.averageMaturityLength}} <br />
                                {{selectedTooltipProduct?.occur}} <br />
                            </p>
                            <!--<a href="" (click)="onAampTooltipLinkClick()">
                                {{selectedTooltipProduct?.numberOfInstruments}} instruments </a>-->
                                <a href="" (click)="onAampTooltipLinkClick()">
                                    {{selectedTooltipProduct?.numberOfInstruments}} instruments </a>
                        </div>
                        <table class="aamp-table">
                            <colgroup>
                                <col class="w-55" />
                                <col />
                                <col />
                                <col />
                                <col />
                            </colgroup>
                            <tr>
                                <th>
                                </th>
                                <th class="text-center" colspan="2">USED</th>
                                <th class="text-center" colspan="2">UNUSED</th>
                            </tr>
                            <tr>
                                <th class="px-pb-10"></th>
                                <th class="text-center px-pb-10">M USD</th>
                                <th class="text-center px-pb-10">%</th>
                                <th class="text-center px-pb-10">M USD</th>
                                <th class="text-center px-pb-10">%</th>
                            </tr>

                            <ng-template ngFor let-item [ngForOf]="derivativeHoldings" let-i="index">
                                <tr class="aamp-row"
                                    [class.orange-row]="item.usedPercentage >= 95 && item.usedPercentage < 100"
                                    [class.red-row]="item.usedPercentage >= 100">
                                    <td class="w-60 px-pb-5">
                                        <div class="d-flex flex-grow-1">
                                            <div class="w-30 text-right">{{item.productName}}</div>
                                            <div class="w-70 px-ms-5">
                                                <div class="w-100 percentage-bar"
                                                    [class.simu-quota]="highlightedSimu[item.productName]"
                                                    (click)="onAampProductClick(item.productName, $event)">
                                                    <div class="bg-bnpp-gray"
                                                        [style.width.%]="item.usedPercentage <= 100 ? item.usedPercentage : 100">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-right px-ps-10 px-pb-5">{{item.formattedUsedQuota}}</td>
                                    <td class="text-left px-ps-10 px-pb-5" *ngIf="item.usedPercentage <= 100">
                                        {{item.maxQuota > 0 ? item.usedPercentage : ''}}
                                    </td>
                                    <td class="text-left px-ps-10 px-pb-5" *ngIf="item.usedPercentage > 100"
                                        title="{{item.usedPercentage}}">100+
                                    </td>
                                    <td class="text-right px-pb-5" *ngIf="(item.maxQuota - item.usedQuota) > 0"
                                        title="{{item.formattedUnused}}">{{item.maxQuota > 0 ? item.formattedUnused :
                                        ''}}
                                    </td>
                                    <td class="text-right px-pb-5" *ngIf="(item.maxQuota - item.usedQuota) <= 0"
                                        title="{{item.formattedUnused}}">0.00
                                    </td>
                                    <td class="text-left px-ps-10 px-pb-5" *ngIf="(item.maxQuota - item.usedQuota) > 0"
                                        title="{{item.unusedPercentage}}">{{item.maxQuota > 0 ? item.unusedPercentage :
                                        ''}}
                                    </td>
                                    <td class="text-left px-ps-10 px-pb-5" *ngIf="(item.maxQuota - item.usedQuota) <= 0"
                                        title="{{item.unusedPercentage}}">0
                                    </td>
                                </tr>
                            </ng-template>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-33 ms-3">
            <div class="card px-ms-10">
                <div class="card-header d-flex flex-row">
                    <div class="me-auto">
                        DERIVATIVE HOLDINGS
                    </div>
                </div>
                <div class="px-p-10 custom-card-body">
                    <app-derivative-holdings-chart [aampUsedQuotaList]="usedQuotaData"
                        [aampUsedSimuQuotaList]="usedQuotaDataSimu"></app-derivative-holdings-chart>
                </div>
            </div>
        </div>
        <div class="w-33 ms-3">
            <div class="card px-ms-10">
                <div class="card-header table-card-header d-flex flex-row">
                    <div class="me-auto">
                        CCR
                    </div>
                </div>
                <div class="custom-card-body px-p-10" *ngIf="!entityCcrExeChartData">
                    <span class="title2">Loading, Please wait...</span>
                </div>
                <div class="custom-card-body px-p-10"
                    *ngIf="entityCcrExeChartData && entityCcrExeChartData.length === 0 && !(entityCcrExeChartDataSimu && entityCcrExeChartDataSimu.length > 0)">
                    <span class="title2">No data</span>
                </div>
                <div class="custom-card-body" *ngIf="entityCcrExeChartData && entityCcrExeChartData.length > 0">
                    <div class="justify-content-center d-flex  px-py-5 card-tool-bar">
                        <div class="bnpp-btn-group btn-group btn-group-toggle me-5" role="group" ngbRadioGroup name="radioBasic"
                            [(ngModel)]="selectedCcrExe">
                            <!--<label ngbButtonLabel class="me-1 ">
                                <input class=" ms-1" ngbButton type="radio" value="CCR"> CCR
                            </label>-->
                            <input type="radio" [(ngModel)]="selectedCcrExe" name="btnradio" value="CCR" class="btn-check" id="btnradio"  >
                            <label class=" btn" for="btnradio" [ngClass]="selectedCcrExe =='CCR' ? 'active':''">CCR</label>
                        </div>

                        <div class="bnpp-btn-group btn-group btn-group-toggle " role="group" aria-label="Radio Buttons with Bootstrap 5" 
                            >

                            <!--<input type="radio" [formControl]="radio" name="btnradio" [value]="1" class="btn-check" id="btnradio1" autocomplete="off">
                             <label class="btn " for="btnradio1">Under 250%</label>
                             <input type="radio" [formControl]="radio" name="btnradio" [value]="1" class="btn-check" id="btnradio2" autocomplete="off">
                             <label class="btn " for="btnradio2">Under 500</label>
                             <input type="radio" [formControl]="radio" name="btnradio" [value]="1" class="btn-check" id="btnradio3" autocomplete="off">
                             <label class="btn " for="btnradio3">Any</label>-->

                            <input type="radio" [(ngModel)]="selectedCcrExeChartMode" name="btnradio" value="250" class="btn-check" id="btnradio1" autocomplete="off">
                            <label class=" btn" [ngClass]="selectedCcrExeChartMode =='250' ? 'active':''" for="btnradio1">Under 250%</label>

                            <input type="radio" [(ngModel)]="selectedCcrExeChartMode" name="btnradio" value="500" class="btn-check" id="btnradio2" autocomplete="off">
                            <label class="btn" [ngClass]="selectedCcrExeChartMode =='500' ? 'active':''" for="btnradio2">Under 500</label>

                            <input type="radio" [(ngModel)]="selectedCcrExeChartMode" name="btnradio" value="0" class="btn-check" id="btnradio3" autocomplete="off">
                            <label class="btn" [ngClass]="selectedCcrExeChartMode =='0' ? 'active':''" for="btnradio3">Any</label>

                            
                        </div>

                    </div>

                    <div>
                        <div class="d-flex flex-row justify-content-between chart-yaxis-title px-px-5">
                            <span class="px-ms-5">CCR %</span>
                            <span></span>
                        </div>
                        <app-entity-ccr-exe-chart [entityCcrExeChartData]="entityCcrExeChartData"
                            [entityCcrExeChartDataSimu]="entityCcrExeChartDataSimu"
                            [maxCcrChartAxis]="selectedCcrExeChartMode"></app-entity-ccr-exe-chart>
                    </div>

                </div>
            </div>
        </div>
    </div>




    <div class="px-mb-20">
        <div class="card">
            <div class="card-header table-card-header d-flex flex-row">
                <div class="me-auto">
                    COUNTERPARTIES
                </div>
            </div>
            <div>
                <div *ngIf="!counterPartyGridData" class="px-p-20">
                    <span class="title2">Loading, Please wait...</span>
                </div>
                <form *ngIf="counterPartyGridData && counterPartyList && counterPartyList.length > 0" [formGroup]="form"
                    novalidate>
                    <table class="counterparty-table" formArrayName="counterParties">
                        <colgroup>
                            <col />
                            <col class="px-w-130" *ngIf="showCounterpartiesGridInputColumns()" />
                            <col class="px-w-130" *ngIf="showCounterpartiesGridInputColumns()" />
                            <col class="px-w-220" />
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                            <col />
                        </colgroup>
                        <tr>
                            <th class="text-center">CPY</th>
                            <th class="text-center" *ngIf="showCounterpartiesGridInputColumns()">SHARE</th>
                            <th class="text-center" *ngIf="showCounterpartiesGridInputColumns()">NOTIONAL</th>
                            <th class="text-center">CCR PROJECTION</th>
                            <th class="text-center" colspan="3">LAST MONTH</th>
                            <th class="text-center" colspan="4">0-2 YEARS</th>
                            <th class="text-center" colspan="3">2-5 YEARS</th>
                            <th class="text-center" colspan="3">5-10 YEARS</th>
                        </tr>
                        <tr>
                            <th></th>
                            <th class="text-center" *ngIf="showCounterpartiesGridInputColumns()">%</th>
                            <th class="text-center" *ngIf="showCounterpartiesGridInputColumns()">USD</th>
                            <th class="text-center">(10 YEAR)</th>
                            <th>WCCR %</th>
                            <th class="group-col">2w VaR M USD</th>
                            <th class="group-col">PLE M USD</th>
                            <th>WCCR %</th>
                            <th class="group-col">2w VaR M USD</th>
                            <th class="group-col">PLE M USD</th>
                            <th class="group-col">DATE</th>
                            <th>WCCR %</th>
                            <th class="group-col">PLE M USD</th>
                            <th class="group-col">DATE</th>
                            <th>WCCR %</th>
                            <th class="group-col">PLE M USD</th>
                            <th class="group-col">DATE</th>
                        </tr>
                        <ng-template ngFor let-item [ngForOf]="counterPartyList.controls" let-i="index">
                            <tr [formGroupName]="i" class="cursor-pointer">
                                <td (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.counterParty}}
                                </td>
                                <td class="input-col" *ngIf="showCounterpartiesGridInputColumns()">
                                    <app-grid-input-control [parentFormGroup]="item"
                                        [dynamicFormControlName]="'notionalSharePercentage'"
                                        (valueChange)="onCounterpartyGridNotionalSharePercentageInputChange($event, i, item)"
                                        (statusChange)="onCounterpartyGridNotionalStatusChange($event)"
                                        (blurr)="onCounterpartyGridNotionalBlur($event, item)">
                                    </app-grid-input-control>
                                </td>
                                <td class="input-col" *ngIf="showCounterpartiesGridInputColumns()">
                                    <app-grid-input-control [parentFormGroup]="item"
                                        [dynamicFormControlName]="'notionalInUsd'"
                                        (valueChange)="onCounterpartyGridNotionalInUsdInputChange($event, i, item)"
                                        (statusChange)="onCounterpartyGridNotionalStatusChange($event)"
                                        (blurr)="onCounterpartyGridNotionalBlur($event, item)">
                                    </app-grid-input-control>
                                </td>
                                <td (click)="gotoCounterParty(item.value.counterParty)">
                                    <app-small-ccr-chart [entityCcrChartData]="item.value.lineChartData">
                                    </app-small-ccr-chart>
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.lastMonthWccr}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.lastMonthW2VarMUsd}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.lastMonthPleMUsd}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.zeroToTwoYearsWccr}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col d-flex flex-row justify-content-start align-items-center">
                                    {{item.value.zeroToTwoYearsW2VarMUsd}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                    <div
                                        class="d-flex flex-row justify-content-center align-items-center px-0 m-auto w-auto position-absolute update-projections">
                                        <button type="button"
                                            class="btn btn-sm btn-basic w-auto bg-white position-relative d-flex flex-row justify-content-center align-items-center px-3 px-mt-n10 overflow-hidden"
                                            *ngIf="i === Math.floor(counterPartyList.controls.length / 2) && showUpdateProjections()"
                                            [class.top-btn-position]="counterPartyList.controls.length === 2"
                                            (click)="updateProjections()">

                                            <div class="clock" [class.d-none]="!projectionsAreBeingUpdated">
                                                <div class="cup top">
                                                    <div class="sand"></div>
                                                </div>
                                                <div class="cup">
                                                    <div class="sand delayed"></div>
                                                </div>
                                            </div>
                                            <span
                                                [class.updating]="projectionsAreBeingUpdated">{{updateProjectionsLabel}}</span>
                                        </button>
                                        <button type="button"
                                            class="btn btn-sm btn-basic w-auto bg-white position-relative px-0 px-mt-n10"
                                            [class.d-none]="projectionsAreBeingUpdated"
                                            *ngIf="i === Math.floor(counterPartyList.controls.length / 2) && showUpdateProjections()"
                                            [class.top-btn-position]="counterPartyList.controls.length === 2"
                                            (click)="resetCpyShareNotional(item)">
                                            <span class="logo-btn-small close"></span>
                                        </button>
                                    </div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.zeroToTwoYearsPleMUsd}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.zeroToTwoYearsDate}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.twoToFiveYearsWccr}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.twoToFiveYearsPleMUsd}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.twoToFiveYearsDate}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.fiveToTenYearsWccr}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.fiveToTenYearsPleMUsd}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                                <td class="group-col" (click)="gotoCounterParty(item.value.counterParty)">
                                    {{item.value.fiveToTenYearsDate}}
                                    <div *ngIf="showUpdateProjections()" class="cell-overlay"></div>
                                </td>
                            </tr>
                        </ng-template>
                    </table>
                </form>

            </div>
        </div>
    </div>
    <div>
        <div class="card">
            <div class="card-header table-card-header d-flex flex-row px-ps-10 cursor-pointer justify-content-between">
                <div class="flex-grow-1 d-flex flex-row" (click)="onInstrumentPanelClick()">
                    <div *ngIf="!instrumentGridCollapse">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 8 8">
                            <path d="M0 0v8l4-4-4-4z" transform="translate(2)" />
                        </svg>
                    </div>
                    <div *ngIf="instrumentGridCollapse">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 8 8">
                            <path d="M0 0l4 4 4-4h-8z" transform="translate(0 2)" />
                        </svg>
                    </div>
                    <div class="me-auto px-ms-5">
                        INSTRUMENTS
                    </div>

                </div>
                <div *ngIf="instrumentGridCollapse">
                    <div class="dropdown">
                        <div id="instrumentDownloadDropdownMenu" class="logo-btn-small download dropdown-toggle"
                            role="button"></div>
                        <div class="dropdown-download dropdown-menu-right">
                            <button class="dropdown-item" (click)="onInstrumentExport()">
                                Download CSV
                            </button>
                        </div>
                    </div>
                </div>

            </div>
            <div class="card-header table-card-header grid-control-bar d-flex flex-row bnpp-regular"
                *ngIf="instrumentGridCollapse">
                <app-horizon-time-range *ngIf="!tooltipClickFilter" [horizon]="instrumentGridToolBarOption.horizon"
                    (updateHorizonTimeRange)="onUpdateHorizonTimeRange($event)"></app-horizon-time-range>


                <div class="custom-form-inline me-auto">
                    <div *ngIf="!tooltipClickFilter">
                        <span class="px-ms-20 ms-2">Instruments:&nbsp; </span>
                        <div class="bnpp-btn-group btn-group btn-group-toggle" role="group"  name="radioBasic">

                            <input type="radio" [(ngModel)]="instrumentGridToolBarOption.instrumentType"
                            (ngModelChange)="selectedGridInstrumentTypeChange($event)" name="btnradio"
                             value=-1 class="btn-check" id="all" autocomplete="off">
                            <label class=" btn" [ngClass]="instrumentGridToolBarOption.instrumentType == -1 ? 'active':''" for="all">All</label>

                            <input type="radio" [(ngModel)]="instrumentGridToolBarOption.instrumentType"
                            (ngModelChange)="selectedGridInstrumentTypeChange($event)" name="btnradio" value=0 class="btn-check" id="derivatives" autocomplete="off">
                            <label class="btn" [ngClass]="instrumentGridToolBarOption.instrumentType == 0 ? 'active':''" for="derivatives">Derivatives</label>

                            <input type="radio" [(ngModel)]="instrumentGridToolBarOption.instrumentType"
                            (ngModelChange)="selectedGridInstrumentTypeChange($event)" name="btnradio" value=1 class="btn-check" id="collateral" autocomplete="off">
                            <label class="btn" [ngClass]="instrumentGridToolBarOption.instrumentType == 1 ? 'active':''" for="collateral">Collateral</label>
                           
                            <!--<label ngbButtonLabel class="ms-1">
                                <input ngbButton type="radio" value="-1"> All
                            </label>

                            <label ngbButtonLabel class="ms-2">
                                <input ngbButton type="radio" value="0"> Derivatives
                            </label>

                            <label ngbButtonLabel class="ms-2 me-1">
                                <input ngbButton type="radio" value="1"> Collateral
                            </label>-->

                        </div>
                    </div>
                </div>


                <div id="aamp-instrument-filter" class="form-inline bg-bnpp-orange2 color-white px-me-20 px-pe-5 br-2"
                    *ngIf="tooltipClickFilter">
                    <div class="px-px-10">
                        <div>{{selectedTooltipProduct?.productName}}
                            instruments({{selectedTooltipProduct?.numberOfInstruments}}) with total notional of
                            {{selectedTooltipProduct?.formattedUsedQuota}}.
                        </div>
                    </div>
                    <span class="logo-btn-small close white" (click)="removeAampTooltipClickFilter()"></span>
                </div>

                <div class="form-inline my-2 my-lg-0">
                    <input class="form-control me-sm-2 form-control-sm grid-filter" type="search" placeholder="Search"
                        [(ngModel)]="instrumentGridToolBarOption.searchText" aria-label="Search">
                </div>
            </div>
            <div *ngIf="instrumentGridCollapse" class="ag-fresh grid_style">
                <ag-grid-angular
                    [gridOptions]="instrumentGridOptions"
                    [components]="components"
                    [quickFilterText]="instrumentGridToolBarOption.searchText" 
                    [columnDefs]="instrumentGridColumnDef"
                    [rowData]="instrumentGridData" 
                    [overlayLoadingTemplate]="overlayLoadingTemplate"
                    [overlayNoRowsTemplate]="overlayNoRowsTemplate" 
                    [suppressRowDeselection]="true"
                    [rowClassRules]="rowClassRules" 
                    (gridReady)="onInstrumentGridReady($event)">
                </ag-grid-angular>
            </div>
        </div>
    </div>

</div>